define('services/myservices/myservice-list.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('getServiceList', ['$q', '$filter', 'ngDialog', 'OpenApp', 'auiDialog', 'huaweiIdService', function ($q, $filter, ngDialog, OpenApp, auiDialog, huaweiIdService) {
        var deleteApiMap = mainCons.myserviceList.deleteApi;
        var deleteApiParamMap = mainCons.myserviceList.deleteApiParam;
        var prodServiceStateValueFilterMap = mainCons.appConstant.serviceStateForManagerFilter;
        var prodServiceopenStateValueFilterMap = mainCons.appConstant.openStateFilter;
        //删除的提示
        var deleteSerTipsMap = mainCons.myserviceList.deleteSerTips;
        var hmsService = [6, 8, 32, 33];//push、支付、帐号、社交
        //删除需要提示的服务
        var dependlist = [6, 8, 52, 32, 33];//push、游戏、帐号、社交


        // 申请下架
        function pullOff(product, serviceItem) {
            var defer = $q.defer();
            ngDialog.open({
                template: 'pages/myservices/common/shelfoff.html',
                className: '',
                controller: ['$scope', function ($scope) {

                    var shelfOffTipsMap = mainCons.myserviceList.shelfOffTips;

                    var Model = $scope.Model = {};
                    Model.reason = '';
                    var key = serviceItem;
                    if ('30' == serviceItem) {
                        key = '30-' + product.prodType;
                    }
                    Model.shelfOffTip = $filter('auiMapWithDefault')(key, shelfOffTipsMap);
                    $scope.close = function () {
                        ngDialog.close();
                    };
                    $scope.shelfoff = shelfoff;

                    function shelfoff() {

                        if ($scope.marketshelfoff.$invalid) {
                            $scope.marketshelfoff.$setDirty();
                            return;
                        }
                        var options = {
                            prodID: +product.prodID,
                            prodType: product.prodType,
                            serviceItem: serviceItem
                        };

                        if ($scope.Model.reason.length > 0) {
                            options.reason = $scope.Model.reason;
                        }
                        OpenApp.shelfOff({request: options}).then(function (res) {
                            ngDialog.close();
                            if (res && res.NSP_STATUS) {
                                defer.reject();
                            } else {
                                defer.resolve(true);
                            }
                        }).catch(function (e) {
                            defer.reject();
                        });
                    }
                }]
            });
            return defer.promise;
        }

        //删除服务
        function deleteSer(product, serviceItem) {
            var defer = $q.defer();
            deleteservice(product, serviceItem).then(function (res) {
                defer.resolve(res);
            });
            return defer.promise;
        }

        function deleteservice(product, serviceItem) {
            var defer = $q.defer();
            OpenApp['delService']({
                request: {
                    prodID: product.prodID,
                    prodType: product.prodType,
                    serviceItem: serviceItem
                }
            }).then(function (res) {
                defer.resolve(res)
            }).catch(function (res) {
                defer.reject(res);
            });
            return defer.promise;
        }


        //删除产品加服务
        function deleteProd(product, serviceItem, flag) {
            var defer = $q.defer();
            var params = {};
            params.request = {};
            params.request[$filter('auiMapWithDefault')($filter('auiMapWithDefault')(product.prodType, deleteApiMap), deleteApiParamMap)] = product.prodID;
            deleteservice(product, serviceItem).then(function (res) {
                if (flag) {
                    OpenApp[$filter('auiMapWithDefault')(product.prodType, deleteApiMap)](params).then(function (data) {
                        defer.resolve(data);
                    }).catch(function (data) {
                        defer.reject(data);
                    });
                } else {
                    defer.resolve(res);
                }
            });
            return defer.promise;
        }

        function deleteAll(prod) {
            var defer = $q.defer();
            var key = prod.serviceSingle.serviceItem;
            if (key == '30') {
                key = '30-' + prod.prodType;
            }
            var servicename = $filter('auiMapWithDefault')(key, deleteSerTipsMap);

            if (checkDependOn(prod)) {
                if (AUI.BaseJSUtil.contains(dependlist, prod.serviceSingle.serviceItem)) {
                    auiDialog.confirm("删除确认", servicename + '删除后，会影响该应用所有在网终端用户的' + servicename + '使用，请谨慎操作。', function () {

                        deleteSer(prod, prod.serviceSingle.serviceItem).then(function (res) {
                            defer.resolve(res);
                        });
                    });
                } else {
                    auiDialog.confirm('确认从' + servicename + '删除该产品？', function () {
                        deleteSer(prod, prod.serviceSingle.serviceItem).then(function (res) {
                            defer.resolve(res);
                        });
                    });
                }
            } else {
                defer.reject();
            }

            return defer.promise;
        }

        /**
         * 检查依赖关系
         * @param prod
         * @returns {boolean}  没有依赖返回true
         */
        function checkDependOn(prod) {

            var ispreloadexsit = false;//当前应用存在预装
            var ishealthyexsit = false;//当前为帐号服务，并且当前应用存在运动健康
            var isapptouchexsit = false;//当前为帐号服务，并且当前应用存在APPTouch服务

            var flag = true;
            var serviceCount = 0;//hms服务的个数

            prod.serviceList.forEach(function (v) {
                if (AUI.BaseJSUtil.contains(hmsService, v.serviceItem)) {
                    serviceCount++;
                }
            });

            if (AUI.BaseJSUtil.contains(hmsService, prod.serviceSingle.serviceItem)) {
                prod.serviceList.forEach(function (v) {
                    if (v.serviceItem === 40) {
                        ispreloadexsit = true;
                    }
                    if (prod.serviceSingle.serviceItem === 32 && v.serviceItem === 43) {
                        ishealthyexsit = true;
                    }
                    if (prod.serviceSingle.serviceItem === 32 && v.serviceItem === 1004) {
                        isapptouchexsit = true;
                    }
                });

                //当前为最后的hms 服务，需要判断依赖关系
                if (serviceCount <= 1) {
                    if (ishealthyexsit || ispreloadexsit || isapptouchexsit) {
                        var dependOnService = [];
                        if (ispreloadexsit) {
                            dependOnService.push("手机预装")
                        }
                        if (ishealthyexsit) {
                            dependOnService.push("运动健康")
                        }
                        if (isapptouchexsit) {
                            dependOnService.push("AppTouch")
                        }
                        var dependOnServiceString = dependOnService.join("、");

                        auiDialog.warn("删除" + $filter('auiMapWithDefault')(prod.serviceSingle.serviceItem, deleteSerTipsMap) + "之前请先删除" + dependOnServiceString + "服务");
                        flag = false;
                    }
                } else {
                    //当前为帐号服务，并且存在运动健康或者APPTouch
                    if (ishealthyexsit || isapptouchexsit) {
                        var dependOnService2 = [];
                        if (ishealthyexsit) {
                            dependOnService2.push("运动健康")
                        }
                        if (isapptouchexsit) {
                            dependOnService2.push("AppTouch")
                        }
                        var dependOnServiceString2 = dependOnService2.join("、");
                        auiDialog.warn("删除" + $filter('auiMapWithDefault')(prod.serviceSingle.serviceItem, deleteSerTipsMap) + "之前请先删除" + dependOnServiceString2 + "服务");
                        flag = false;
                    }
                }
            }

            return flag;

        }

        function checkPaidService() {
            var defer = $q.defer();
            defer.resolve({checkResult: 0});
            return defer.promise;
        }

        function checkIsHasVrProd(serviceItem) {
            var defer = $q.defer();
            if (serviceItem == 4 || serviceItem == 6 || serviceItem == 32 || serviceItem == 33) {
                OpenApp.getProListByService({
                    request: {
                        serviceItem: serviceItem,
                        prodType: [8]
                    }
                }).then(function (res) {
                    defer.resolve(res);
                }).catch(function (res) {
                    defer.resolve(res);
                });
            } else {
                defer.resolve({retCount: 0, totalCount: 0});
            }
            return defer.promise;
        }

        function getWorkOrdersCreateTime(serviceItem, prodID, prodList) {
            var defer = $q.defer();
            if (prodList && prodList.length > 0) {
                prodList.forEach(function (pro) {
                    if (pro.prodID == prodID) {
                        pro.serviceList.forEach(function (v) {
                            if (v.serviceItem == serviceItem) {
                                defer.resolve(v.workOrdersCreateTime);
                            }
                        });
                    }
                });
            } else {
                OpenApp.getProListByService({
                    request: {
                        serviceItem: serviceItem,
                        prodID: prodID
                    }
                }).then(function (data) {
                    var productList = data.productList;
                    if (productList && productList.length > 0) {
                        productList.forEach(function (pro) {
                            pro.serviceList.forEach(function (v) {
                                if (v.serviceItem == serviceItem) {
                                    defer.resolve(v.workOrdersCreateTime);
                                }
                            });

                        });
                    }
                }).catch(function (res) {
                    defer.reject(res);
                });
            }
            return defer.promise;
        }

        function improveProduct(pro, serviceItem) {
            pro.prodTypeName = $filter("appsrfs")(pro);
            pro.serviceList.forEach(function (v) {
                if (v.serviceItem == serviceItem) {
                    pro.status = isDistributionService(v.serviceItem) ? ($filter('auiMapWithDefault')(v.serviceState, prodServiceStateValueFilterMap)) : ($filter('auiMapWithDefault')(v.openState, prodServiceopenStateValueFilterMap));
                    pro.serviceSingle = angular.copy(v);
                    if (serviceItem == 4) {
                        //处理灰度发布
                        if (pro.serviceSingle.lastSrvSerialNo && pro.serviceSingle.lastSrvSerialNo > 0) {
                            OpenApp.getServiceInfo({
                                request: {
                                    serviceItem: 4,
                                    srvSerialNo: pro.serviceSingle.lastSrvSerialNo
                                }
                            }).then(function (res) {
                                pro.serviceSingle.releaseType = (angular.fromJson(res.serviceInfo.serviceAttrs)) && (angular.fromJson(res.serviceInfo.serviceAttrs)).releaseType == 2 ? 2 : 0;
                            });
                        }
                    }
                }
            });
        }

        function isDistributionService(item) {
            return AUI.BaseJSUtil.contains(mainCons.appConstant.growServices, item);
        }

        function updateProdcutType(prodTypeArr, serviceItem) {
            var objStr = window.sessionStorage.getItem("Model.app.query.tableHeader")
            var obj = {};
            if (objStr) {
                obj = JSON.parse(objStr);
                /*如果无法转换则删除*/
                if (typeof obj == 'string' || !obj) {
                    window.sessionStorage.removeItem("Model.app.query.tableHeader");
                }
            }
            obj["serviceItem" + serviceItem] = prodTypeArr;
            window.sessionStorage.setItem("Model.app.query.tableHeader", JSON.stringify(obj));
        }

        function getProductType(serviceItem) {
            var objStr = window.sessionStorage.getItem("Model.app.query.tableHeader")
            var obj = {};
            /**json 格式{'30':[],'59':[],...}*/
            if (objStr) {
                obj = JSON.parse(objStr);
                /*如果无法转换则删除*/
                if (typeof obj == 'string' || !obj) {
                    window.sessionStorage.removeItem("Model.app.query.tableHeader");
                }
            }
            return obj["serviceItem" + serviceItem];
        }

        return {
            pullOff: pullOff,
            deleteSer: deleteSer,
            deleteProd: deleteProd,
            deleteAll: deleteAll,
            checkPaidService: checkPaidService,
            checkIsHasVrProd: checkIsHasVrProd,
            getWorkOrdersCreateTime: getWorkOrdersCreateTime,
            improveProduct: improveProduct,
            updateProdcutType: updateProdcutType,
            getProductType: getProductType
        }

    }]);
});


